// extracted by mini-css-extract-plugin
module.exports = {"container":"_02712f2b3b--container--qAx0q","image":"_02712f2b3b--image--tfctd","title":"_02712f2b3b--title--dZd34","description":"_02712f2b3b--description--C2gKE"};